// genders
export const BEAUTY_GENDERS = ["Жінкам", "Чоловікам", "Унісекс / Для всіх"];

// sections by gender
const SECTIONS_BY_GENDER = {
  "Жінкам": [
    "Волосся",
    "Обличчя",
    "Нігті",
    "Тіло та ванна",
    "Парфумерія",
    "Аксесуари",
  ],
  "Чоловікам": [
    "Волосся",
    "Обличчя",
    "Борода та вуса",
    "Нігті",
    "Тіло та ванна",
    "Парфумерія",
    "Аксесуари",
  ],
  "Унісекс / Для всіх": [
    "Волосся",
    "Обличчя",
    "Нігті",
    "Тіло та ванна",
    "Парфумерія",
    "Аксесуари",
  ],
};

// subcategories (only where useful)
const SUBCATS_BY_SECTION = {
  "Волосся": [
    "Шампуні",
    "Догляд (маски/бальзами)",
    "Фарби / Відтінки",
    "Техніка для волосся",
  ],
  "Обличчя": [
    "Догляд",
    "Макіяж",
    "Очищення",
    "SPF",
    "Набори",
  ],
  "Борода та вуса": [
    "Догляд (олії/бальзами)",
    "Стайлінг (віск/крем)",
    "Фарбування",
  ],
  "Нігті": [
    "Лаки / Гель-лаки",
    "Зняття покриття",
    "Аксесуари / Інструменти",
    "Техніка для майстрів",
    "Догляд / Лікувальні",
  ],
  "Тіло та ванна": [
    "Креми / Лосьйони / Олії",
    "Для душу / ванни",
    "Дезодоранти / Антиперспіранти",
    "Гоління / Депіляція",
    "Гігієна порожнини рота",
    "Інтимна / Жіноча гігієна",
    "Паперові вироби",
  ],
  // "Парфумерія" та "Аксесуари" — без підкатегорій
};

// fields
export const beautyFields = (attrs) => {
  const a = attrs || {};
  const gender = a.gender || a.department || "";
  const section = a.section || "";

  const genderOnly = [
    {
      name: "gender",
      label: "Стать / Для кого *",
      type: "select",
      options: BEAUTY_GENDERS,
      required: true,
    },
  ];
  if (!gender) return genderOnly;

  const sectionOnly = [
    ...genderOnly,
    {
      name: "section",
      label: "Розділ",
      type: "select",
      options: SECTIONS_BY_GENDER[gender] || [],
      required: false,
    },
  ];
  if (!section) return sectionOnly;

  const needsSubcat =
    Array.isArray(SUBCATS_BY_SECTION[section]) &&
    SUBCATS_BY_SECTION[section].length > 0;

  if (!needsSubcat) return sectionOnly;

  return [
    ...sectionOnly,
    {
      name: "subcategory",
      label: "Підкатегорія",
      type: "select",
      options: SUBCATS_BY_SECTION[section] || [],
      required: false,
    },
  ];
};
